import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import Auth from '@aws-amplify/auth';

import { App } from './app/app.component';
import { AppConfigProvider } from './app/shared/context';
import { AppConfig } from './app/shared/models';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if ((error as any)?.code === 'NotAuthorizedException') {
          return false;
        }

        return failureCount < 2;
      },
    },
  },
});

export const bootstrapApp = (config: AppConfig) => {
  Auth.configure(config.auth);

  if (process.env.REACT_APP_ENABLE_MOCK_SERVICE_WORKER === 'true') {
    const { worker } = require('./api-mocks/browser');
    worker.start();
  }

  ReactDOM.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppConfigProvider config={config}>
          <App />
        </AppConfigProvider>
      </QueryClientProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
};
